import Vuex from 'vuex' 
import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)
if(!window.Promise){
    window.Promise = Vue.Promise
}

Vue.use(Vuex)
const extend = function(target, param){
    for(var key in param){
        if (param.hasOwnProperty(key)) {
            const targetValue = target[key]
            const paramValue = param[key]
            if(typeof targetValue === 'object' && typeof paramValue === 'object'){
                extend (targetValue, paramValue)
            }else{
                target[key] = param[key]
            }
        }
    }
}
const param = localStorage.param ? JSON.parse(localStorage.param) : {}
//保存页面参数，router的param后退时失效
const paramStore = {
    state:{
        param:param
    },
    mutations:{
        updateParam(state, payload){
            if(!payload || !payload.namespace){
                return;
            }
            var namespace = payload.namespace
            state.param[namespace] = state.param[namespace] || {};
            extend(state.param[payload.namespace], payload)
            localStorage.param = JSON.stringify(state.param)
        },
        clearParam(state, namespace){
            if(!namespace){
                return;
            }
            state.param[namespace] = null;
            if('all' === namespace){
                state.param = {};
            }
            localStorage.removeItem('param');
        }
    }
}
const pagetateStore = {
    state:{
        //保存首页tab选中状态
        tabActive:'Home',
        //弹出框的显示状态
        popupActive:false,
        count:{}
    },
    mutations:{
        changeState(state, viewName){
            state.tabActive = viewName
        },
        togglePopup(state, toggle){
            state.popupActive = toggle
        },
        countdown(state,namespace){
            let count = state.count[namespace];

            const taskId = setInterval(()=>{
                --count;
                if(count === 0){
                    clearInterval(taskId)
                    count = 60
                }
                Vue.set(state.count,namespace,count);
            },1000)
        },
        initCountdown(state,namespace){
             Vue.set(state.count,namespace,60);
        }
    }
}
module.exports = new Vuex.Store({
    modules:{ 
        paramModule:paramStore,
        stateModule:pagetateStore
    }
})


// WEBPACK FOOTER //
// ./src/store/profileStore.js